import type { Bid } from '@/api';

/**
 * Ставки, які ще живі: дилер їх веде, і депозит під них утримано.
 *
 * Визначення спільне для Dashboard і бічної панелі навмисно. Поки воно було
 * локальною константою сторінки, будь-яка правка розводила два числа, що
 * стоять на екрані поруч: картка казала б одне, панель — інше.
 */
export const ACTIVE_BID_STATUSES: Bid['status'][] = ['PENDING', 'ACTIVE', 'HIGHEST_BIDDER', 'OUTBID'];

export const isActiveBid = (bid: Bid): boolean => ACTIVE_BID_STATUSES.includes(bid.status);

/**
 * Торги минули, а результату ще немає: Won чи Lost ставить оператор, коли
 * звірить майданчик. Дилер у цей час бачив «Active» чи «Pending», ніби торги
 * попереду. Це підпис від дати торгів, а не новий статус: у базі ставка
 * лишається, як була (рішення 2026-10-21).
 */
export function isAwaitingResult(bid: Pick<Bid, 'status' | 'auctionAt'>, now: number = Date.now()): boolean {
	return ACTIVE_BID_STATUSES.includes(bid.status) && bid.auctionAt !== null && Date.parse(bid.auctionAt) <= now;
}
